import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, takeawayList } = useSelector((state) => state.auth);

  // User is authenticated if they have a takeawayList (even after reload)
  const isUserAuthenticated = isAuthenticated || (takeawayList && takeawayList.length > 0);

  if (!isUserAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;


